import translate from "../../../common/Dictionary";
import chevronRight from "../../../../img/chevron_right.svg";

const StepIndicator = ({ activeTab, userData }) => {
    return (
        <div className="d-flex axa-steps-list">
            <div className="flex-fill axa-step-list-item bg-grey-100 px-0 active axa-project-steps-border-color">
                <span className="axa-stepbar-number active me-1">1</span>
                <label className={"axa-stepsbar-text past axa-mobile-hidden"}>{translate("newProjectStepService", userData.language)}</label>
            </div>
            <div className="axa-step-list-item bg-grey-100 px-0 active axa-project-steps-border-color">
                <img src={chevronRight} alt="chv-r-1" />
            </div>
            <div className={"flex-fill axa-step-list-item bg-grey-100 px-0 axa-project-steps-border-color " + (activeTab >= 2 ? "active" : "")} align="center">
                <span className={"axa-stepbar-number me-1 " + (activeTab >= 2 ? "active" : "")}>2</span>
                <label className={"axa-stepsbar-text axa-mobile-hidden " + (activeTab >= 2 ? "past" : "")}>{translate("newProjectStepExpert", userData.language)}</label>
            </div>
            <div className={"axa-step-list-item bg-grey-100 px-0 axa-project-steps-border-color " + (activeTab >= 2 ? "active" : "")} align="center">
                <img src={chevronRight} alt="chv-r-1" />
            </div>
            <div className={"flex-fill axa-step-list-item bg-grey-100 px-0 axa-project-steps-border-color " + (activeTab >= 3 ? "active" : "")} align="center">
                <span className={"axa-stepbar-number me-1 " + (activeTab >= 3 ? "active" : "")}>3</span>
                <label className={"axa-stepsbar-text axa-mobile-hidden " + (activeTab >= 3 ? "past" : "")}>{translate("newProjectStepDetails", userData.language)}</label>
            </div>
            <div className={"axa-step-list-item bg-grey-100 px-0 axa-project-steps-border-color " + (activeTab >= 3 ? "active" : "")} align="center">
                <img src={chevronRight} alt="chv-r-1" />
            </div>
            <div className={"flex-fill axa-step-list-item bg-grey-100 px-0 axa-project-steps-border-color " + (activeTab >= 4 ? "active" : "")} align="center">
                <span className={"axa-stepbar-number me-1 " + (activeTab >= 4 ? "active" : "")}>4</span>
                <label className={"axa-stepsbar-text axa-mobile-hidden " + (activeTab >= 4 ? "past" : "")}>{translate("newProjectStepIformation", userData.language)}</label>
            </div>
            <div className={"axa-step-list-item bg-grey-100 px-0 axa-project-steps-border-color " + (activeTab >= 4 ? "active" : "")} align="center">
                <img src={chevronRight} alt="chv-r-1" />
            </div>
            <div className={"flex-fill axa-step-list-item bg-grey-100 px-0 axa-project-steps-border-color " + (activeTab >= 5 ? "active" : "")} align="center">
                <span className={"axa-stepbar-number me-1 " + (activeTab >= 5 ? "active" : "")}>5</span>
                <label className={"axa-stepsbar-text axa-mobile-hidden " + (activeTab >= 5 ? "past" : "")}>{translate("newProjectStepConfirmation", userData.language)}</label>
            </div>
        </div>
    );
};

export default StepIndicator;
